import useExperiences from 'hooks/Experiences/useExperiences'
import type { ExperienceItem } from 'tripPlanner/types/tripItem'
import LEExperienceSummaryCard from './LEExperienceSummaryCard'

interface Props {
  item: ExperienceItem
  experienceId: string
  onClose: () => void
}

function SavedLEExperienceSummaryCard({ item, experienceId, onClose }: Props) {
  const [[experience], isLoading] = useExperiences([experienceId])

  if (isLoading || !experience) {
    return null
  }

  return <LEExperienceSummaryCard experience={experience} tripItem={item} onClose={onClose} />
}

export default SavedLEExperienceSummaryCard
